import React, {
  useEffect,
  useContext,
  useState,
  useMemo,
  useCallback,
} from "react";
import Dashboard from "./Components/Dashboard";
//import { toast } from "react-toastify";
import { apiCall, apiClient } from "../../utils/httpClient";
import ApiEndPoint from "../../utils/apiEndPoints";
import { LocalStorageKeys, LocalStorageService } from "../../utils/LocalStorageService";
import { LoaderContext, SourceContext } from "../../Context/userContext";
import { biomarkercolors } from "../../utils/constants";
import { TransformRawObjectData } from "../../utils/TransformObject";
import { normalizeClinicalSignificanceData, expandClinicalSignificanceFilter } from "../../utils/clinicalSignificanceMapping";
import { useDateRange } from "../../hooks/useDateRange";
import {
  UserDatailContext,
} from "../../Context/userContext.js";
import {Roles} from "../../utils/roles";

const DashboardScreen = () => {
  const [IsLoading] = useContext(LoaderContext);
  const {
    lungClicked,
    genderFilter,
    setGenderDropdown,
    is1kViewEnabled
  } = useContext(SourceContext);
  const [cancerSiteRestOfData, setCancerSiteRestOf] = useState([]);
  const [cancerSiteTop10Data, setCancerSiteTop10] = useState([]);
  const [cancerDropdown, setCancerDropdown] = useState([]);
  const [filterVal, setFilterVal] = useState("");
  const [morphologyDropdown, setMorphologyDropdown] = useState([]);
  const [cancerFilterVal, setCancerFilterVal] = useState([]);
  const [cancerFilterVal1, setCancerFilterVal1] = useState([]);
  const [morphologyFilterVal, setMorphologyFilterVal] = useState([]);
  const [genderAgeGroup, setGenderAgeGroup] = useState([]);
  const [tmbData, setTmbData] = useState([]);
  const [msiData, setMsiData] = useState([]);
  const [pdlData, setPdlData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [top10totalCount, setTop10TotalCount] = useState(0);
  const [treatmentDetails, setTreatmentDetails] = useState([]);
  const [drugTherapy, setDrugTherapy] = useState([]);
  const [biologicalTherapy, setBiologicalTherapy] = useState([]);
  const [totalValue, setTotalValue] = useState([]);
  const [primarySite, setPrimarySite] = useState([]);
  const [tmbTotal, setTmbTotal] = useState([]);
  const [msiTotal, setMsiTotal] = useState([]);
  const [pdlTotal, setPdlTotal] = useState([]);
  const [treatmentsTotal, setTreatmentsTotal] = useState(0);
  const [drugTotal, setDrugTotal] = useState(0);
  const [biologicalTotal, setBiologicalTotal] = useState(0);
  const [cansiteName, setCansiteName] = useState([]);
  const [geneCancer, setGeneCancer] = useState(null);
  const [geneCancerAllDataList, setGeneCancerAllDataList] = useState(null);
  const [drugsCountTotal, setDrugsCountTotal] = useState([]);
  const [drugsCount, setDrugsCount] = useState([]);
  const [recistCriteria, setRecistCriteria] = useState([]);
  const [recistCriteriaTotal, setRecistCriteriaTotal] = useState([]);
  const [somaticGermline, setSomaticGermline] = useState([]);
  const [variantTypeResponse, setVariantTypeResponse] = useState([]);
  const [somaticTotal, setSomaticTotal] = useState([]);
  const [variantTypeTotal, setVariantTypeTotal] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedGenes, setSelectedGenes] = useState([]);
  const [immunoFilter, setImmunoFilter] = useState([]);
  const [targetedFilter, setTargetedFilter] = useState([]);
  const [citiesFilter, setCitiesFilter] = useState([]);
  const [hospitalsFilter, setHospitalsFilter] = useState([]);
  const [colorMapping, setColorMapping] = useState({});
  const [dateRange, setDateRange] = useState({ fromDate: null, toDate: null });
  const [hospitalCityTotal, setHospitalCityTotal] = useState([]);
  const [hospitalCityData, setHospitalCityData] = useState([]);
  const [hospitalNameData, setHospitalNameData] = useState(null);
  const [proteinChangeDetails, setProteinChangeDetails] = useState([]);
  const [citiesFilterData, setCitiesFilterData] = useState([]);
  const [hospitalsFilterData, setHospitalsFilterData] = useState([]);
  const [immunoFilterData, setImmunoFilterData] = useState([]);
  const [targetedFilterData, setTargetedFilterData] = useState([]);
  const [morphTotalCount, setMorphTotalCount] = useState([]);
  const [testTypeTotalCount, setTestTypeTotalCount] = useState([]);
  const [doctorsDropdownDataFilter, setDoctorsDropdownDataFilter] = useState([]);
  const [doctorsDropdownData, setDoctorsDropdownData] = useState([]);


  // const [lungClicked, setLungClicked] = useState(false);
  const initialValue = 0;
  const [CancerSitesLoader, setCancerSitesLoader] = useState(false);
  const [MorphologySomaticGermlineLoader, setMorphologySomaticGermlineLoader] = useState(false);
  const [BiomarkersLoader, setBiomarkersLoader] = useState(false);
  const [TmbMsiPdlLoader, setTmbMsiPdlLoader] = useState(false);
  const [TreatmentDetailsLoader, setTreatmentDetailsLoader] = useState(false);
  const [DrugTherapyLoader, setDrugTherapyLoader] = useState(false);
  const [GenderAgeDistrubtutionLoader, setGenderAgeDistrubtutionLoader] = useState(false);
  const [HospitalTestTypeLoader, setHospitalTestTypeLoader] = useState(false);
  const [morphologyDataLoader, setMorphologyDataLoader] = useState(false);
  const [testTypeGraphLoader, setTestTypeGraphLoader] = useState(false);
  const [targetedTherapy, setTargetedTherapy] = useState([]);
  const [targetedTherapyTotal, setTargetedTherapyTotal] = useState(0);
  const [isPdlChecked, setIsPdlChecked] = useState(false);
  const [ngsValue, setNgsValue] = useState(null);
  const [cancerStage, setCancerStage] = useState([]);
  const [cancerStageTotal, setCancerStageTotal] = useState(0);
  const [wasManuallyCleared, setWasManuallyCleared] = useState(false);
  const [testTypeFilterData, setTestTypeFilterData] = useState([]);
  const [testTypeFilter, setTestTypeFilter] = useState([]);
  const [morphologyData, setMorphologyData] = useState([]);
  const [testTypeGraphData, setTestTypeGraphData] = useState([]);
  const [geneDetectionStatus, setGeneDetectionStatus] = useState(null);
  const [debouncedFilters, setDebouncedFilters] = useState([]);
  const [clinicalSignificanceDropdown, setClinicalSignificanceDropdown] =
    useState([]);
  const [clinicalSignificanceFilter, setClinicalSignificanceFilter] = useState(
    []
  );

  const getGenderParam = (genderFilter) =>
    genderFilter?.length > 0
      ? genderFilter.map((g) => g.name)
      : null;

  // Prepare filters for date range API
  const dateRangeFilters = useMemo(() => ({
    genes: selectedGenes,
    testNameDetails: testTypeFilter,
    cancerSite: cancerFilterVal1,
    immunoTherapy: immunoFilter,
    targetedTherapy: targetedFilter,
    morphologyTypes: morphologyFilterVal,
    hospitalCity: citiesFilter,
    hospitalName: hospitalsFilter,
    genderFilter: getGenderParam(genderFilter),
    doctorsData: doctorsDropdownDataFilter,
    // clinicalSignificanceOfVariance: clinicalSignificanceFilter,
    ngsFilterType: ngsValue,
    pdlFilter: isPdlChecked,
    lungsAlliance: lungClicked,
    ngsGeneDetectFilter: geneDetectionStatus,
  }), [
    selectedGenes,
    testTypeFilter,
    cancerFilterVal1,
    immunoFilter,
    targetedFilter,
    morphologyFilterVal,
    citiesFilter,
    hospitalsFilter,
    genderFilter,
    doctorsDropdownDataFilter,
    clinicalSignificanceFilter,
    ngsValue,
    isPdlChecked,
    lungClicked,
    geneDetectionStatus
  ]);

  // Fetch dynamic date range based on filters
  const { dateRange: apiDateRange, loading: dateRangeLoading, hasApiData } = useDateRange({
    ...dateRangeFilters, is1kViewEnabled
  });

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedFilters(cancerFilterVal1);
    }, 400);

    return () => clearTimeout(timeout);
  }, [cancerFilterVal1]);

  const userDetails = LocalStorageService.get(LocalStorageKeys.USER_DETAILS);
  const [hasLungCancerSite, setHasLungCancerSite] = useState(false);
  
  useEffect(() => {
    const fetchLungAccess = async () => {
      try {
        const response = await apiCall("GET", ApiEndPoint.checkHasLungAccess);
        const payload = response?.data?.payLoad;
        setHasLungCancerSite(Boolean(payload));
      } catch (error) {
        console.error("Failed to fetch lung access flag", error);
        setHasLungCancerSite(false);
      }
    };

    if(userDetails?.role == Roles.DOCTOR_ANALYST){
      fetchLungAccess();
    }    
  }, []);

  useEffect(() => {
    CancerSitesAPICall();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [debouncedFilters]);
  const cancerGroups = useMemo(() => [
    {
      name: "Colorectal",
      sites: ["Large Intestine", "Rectum", "Rectosigmoid junction"],
    },
    {
      name: "Head and Neck",
      sites: [
        "Nasopharynx",
        "Oropharynx",
        "Hypopharynx",
        "Pyriform sinus",
        "Tonsil",
        "Other and unspecified major salivary gland",
        "Accessory sinuses",
        "Larynx",
        "Parotid gland",
        "Nasal cavity and middle ear",
        "Eye",
        "Lip",
        "Base of Tongue",
        "Other parts of tongue",
        "Gum",
        "Floor of mouth",
        "Palate",
        "Other and unspecified parts of mouth",
        "Other and ill-defined sites in lip, oral cavity and pharynx",
      ],
    },
    {
      name: "Female Reproductive system",
      sites: [
        "Cervix Uteri",
        "Corpus Uteri",
        "Ovary",
        "Labia,Vulva",
        "Uterus",
        "Vagina",
        "Fallopian tube and other regions",
      ],
    },
    {
      name: "Male Reproductive system",
      sites: [
        "Prostate",
        "Testis",
        "Penis",
        "Other unspecified male genital organs",
      ],
    },
    {
      name: "Brain and nervous system",
      sites: [
        "Brain",
        "Cerebral Meninges",
        "Peripheral nerves and autonomous nervous system",
        "Spinal Cord and Other Central Nervous System",
      ],
    },
    {
      name: "Endocrine System",
      sites: ["Thyroid", "Adrenal gland", "Other endocrine glands"],
    },
    {
      name: "Hepatobiliary Cancer",
      sites: [
        "Liver and intrahepatic bile ducts",
        "Gallbladder",
        "Other and unspecified biliary tract",
      ],
    },
    {
      name: "Urinary Tract Cancer",
      sites: [
        "Kidney",
        "Renal pelvis",
        "Ureter",
        "Urinary Bladder",
        "Other and unspecified urinary organs",
      ],
    },
    {
      name: "Gastrointestinal cancers",
      sites: [
        "Esophagus",
        "Intestinal tract",
        "Stomach",
        "Small Intestine",
        "Retroperitoneum and Peritoneum",
        "Colon(Large Intestine)",
        "Pancreas",
        "Anus and Anal canal",
      ],
    },
    {
      name: "Bone and soft tissue",
      sites: [
        "Bones, joints and articular cartilage of other/ unspecified sites",
        "Bones, joints, and articular cartilage of the limb",
        "Connective, subcutaneous and other soft tissues",
      ],
    },
    {
      name: "Blood and Lymph system",
      sites: ["Hematopoietic and Reticuloendothelial System", "Lymphnode"],
    },
    { name: "Lung", sites: ["Lung"] },
    { name: "Breast", sites: ["Breast"] },
    { name: "Unknown primary", sites: ["Unknown primary"] },
    {
      name: "Other sites",
      sites: ["Respiratory tracts", "Skin", "Thymus", "Trachea"],
    },
  ],
    []
  );
const formatDate = (value) => {
  if (!value) return null;

  const date = new Date(value);
  if (isNaN(date.getTime())) return null;

  const year = date.getFullYear();
  if (year < 1900 || year > 2099) return null;

  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");

  return `${yyyy}-${mm}-${dd}`;
};
  const params = useMemo(
    () => ({
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
      cancerSite: cancerFilterVal1?.length > 0 ? cancerFilterVal1 : null,
      genes:
        selectedGenes?.length > 0
          ? selectedGenes.map((gene) => gene.biomarkerName)
          : null,
      immunoTherapy:
        immunoFilter?.length > 0
          ? immunoFilter.map((immuno) => immuno.name)
          : null,
      hospitalCity:
        citiesFilter?.length > 0 ? citiesFilter.map((city) => city.name) : null,
      hospitalName:
        hospitalsFilter?.length > 0
          ? hospitalsFilter.map((hospital) => hospital.name)
          : null,
      lungsAlliance: lungClicked,
      pdlFilter: isPdlChecked,
      ngsFilterType: ngsValue,
      ngsGeneDetectFilter: geneDetectionStatus,
      testNameDetails:
        testTypeFilter?.length > 0
          ? testTypeFilter.map((test) => test.name)
          : null,
      morphologyTypes:
        morphologyFilterVal?.length > 0
          ? morphologyFilterVal.map((morph) => morph.name)
          : null,
      targetedTherapy:
        targetedFilter?.length > 0
          ? targetedFilter.map((targeted) => targeted.name)
          : null,
      doctorsData:
        doctorsDropdownDataFilter?.length > 0
          ? doctorsDropdownDataFilter.map(doctor => doctor.name)
          : null,
      genderFilter: getGenderParam(genderFilter),
      clinicalSignificanceOfVariance:
        expandClinicalSignificanceFilter(clinicalSignificanceFilter),
    }),
    [
      fromDate,
      toDate,
      cancerFilterVal1,
      selectedGenes,
      immunoFilter,
      citiesFilter,
      hospitalsFilter,
      lungClicked,
      isPdlChecked,
      ngsValue,
      testTypeFilter,
      morphologyFilterVal,
      targetedFilter,
      doctorsDropdownDataFilter,
      geneDetectionStatus,
      genderFilter,
      clinicalSignificanceFilter,
    ]
  );

  const cancerSiteparams = useMemo(
    () => ({
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
      cancerSite: null,
      genes:
        selectedGenes?.length > 0
          ? selectedGenes.map((gene) => gene.biomarkerName)
          : null,
      immunoTherapy:
        immunoFilter?.length > 0
          ? immunoFilter.map((immuno) => immuno.name)
          : null,
      hospitalCity:
        citiesFilter?.length > 0 ? citiesFilter.map((city) => city.name) : null,
      hospitalName:
        hospitalsFilter?.length > 0
          ? hospitalsFilter.map((hospital) => hospital.name)
          : null,
      lungsAlliance: lungClicked,
      pdlFilter: isPdlChecked,
      ngsFilterType: ngsValue,
      testNameDetails:
        testTypeFilter?.length > 0
          ? testTypeFilter.map((test) => test.name)
          : null,
      morphologyTypes:
        morphologyFilterVal?.length > 0
          ? morphologyFilterVal.map((morph) => morph.name)
          : null,
      targetedTherapy:
        targetedFilter?.length > 0
          ? targetedFilter.map((targeted) => targeted.name)
          : null,
      doctorsData:
        doctorsDropdownDataFilter?.length > 0
          ? doctorsDropdownDataFilter.map(doctor => doctor.name)
          : null,
      ngsGeneDetectFilter: geneDetectionStatus,
      genderFilter: getGenderParam(genderFilter),
      clinicalSignificanceOfVariance:
        clinicalSignificanceFilter?.length > 0
          ? clinicalSignificanceFilter.map((item) => item.name)
          : null,
    }),

    [
      fromDate,
      toDate,
      selectedGenes,
      immunoFilter,
      citiesFilter,
      hospitalsFilter,
      lungClicked,
      isPdlChecked,
      ngsValue,
      testTypeFilter,
      morphologyFilterVal,
      targetedFilter,
      doctorsDropdownDataFilter,
      geneDetectionStatus,
      genderFilter,
      clinicalSignificanceFilter,
    ]
  );

  const genesParams = useMemo(
    () => ({
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
      cancerSite: cancerFilterVal1?.length > 0 ? cancerFilterVal1 : null,
      genes: null,
      immunoTherapy:
        immunoFilter?.length > 0
          ? immunoFilter.map((immuno) => immuno.name)
          : null,
      hospitalCity:
        citiesFilter?.length > 0 ? citiesFilter.map((city) => city.name) : null,
      hospitalName:
        hospitalsFilter?.length > 0
          ? hospitalsFilter.map((hospital) => hospital.name)
          : null,
      lungsAlliance: lungClicked,
      pdlFilter: isPdlChecked,
      ngsFilterType: ngsValue,
      testNameDetails:
        testTypeFilter?.length > 0
          ? testTypeFilter.map((test) => test.name)
          : null,
      morphologyTypes:
        morphologyFilterVal?.length > 0
          ? morphologyFilterVal.map((morph) => morph.name)
          : null,
      targetedTherapy:
        targetedFilter?.length > 0
          ? targetedFilter.map((targeted) => targeted.name)
          : null,
      doctorsData:
        doctorsDropdownDataFilter?.length > 0
          ? doctorsDropdownDataFilter.map(doctor => doctor.name)
          : null,
      ngsGeneDetectFilter: geneDetectionStatus,
      genderFilter: getGenderParam(genderFilter),
      clinicalSignificanceOfVariance:
        clinicalSignificanceFilter?.length > 0
          ? clinicalSignificanceFilter.map((item) => item.name)
          : null,
    }),
    [
      fromDate,
      toDate,
      cancerFilterVal1,
      immunoFilter,
      citiesFilter,
      hospitalsFilter,
      lungClicked,
      isPdlChecked,
      ngsValue,
      testTypeFilter,
      morphologyFilterVal,
      targetedFilter,
      doctorsDropdownDataFilter,
      geneDetectionStatus,
      genderFilter,
      clinicalSignificanceFilter,
    ]
  );

  const immunoTherapyParams = useMemo(
    () => ({
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
      cancerSite: cancerFilterVal1?.length > 0 ? cancerFilterVal1 : null,
      genes:
        selectedGenes?.length > 0
          ? selectedGenes.map((gene) => gene.biomarkerName)
          : null,
      immunoTherapy: null,
      hospitalCity:
        citiesFilter?.length > 0 ? citiesFilter.map((city) => city.name) : null,
      hospitalName:
        hospitalsFilter?.length > 0
          ? hospitalsFilter.map((hospital) => hospital.name)
          : null,
      lungsAlliance: lungClicked,
      pdlFilter: isPdlChecked,
      ngsFilterType: ngsValue,
      testNameDetails:
        testTypeFilter?.length > 0
          ? testTypeFilter.map((test) => test.name)
          : null,
      morphologyTypes:
        morphologyFilterVal?.length > 0
          ? morphologyFilterVal.map((morph) => morph.name)
          : null,
      targetedTherapy:
        targetedFilter?.length > 0
          ? targetedFilter.map((targeted) => targeted.name)
          : null,
      doctorsData:
        doctorsDropdownDataFilter?.length > 0
          ? doctorsDropdownDataFilter.map(doctor => doctor.name)
          : null,
      ngsGeneDetectFilter: geneDetectionStatus,
      genderFilter: getGenderParam(genderFilter),
      clinicalSignificanceOfVariance:
        clinicalSignificanceFilter?.length > 0
          ? clinicalSignificanceFilter.map((item) => item.name)
          : null,
    }),
    [
      fromDate,
      toDate,
      cancerFilterVal1,
      selectedGenes,
      citiesFilter,
      hospitalsFilter,
      lungClicked,
      isPdlChecked,
      ngsValue,
      testTypeFilter,
      morphologyFilterVal,
      targetedFilter,
      doctorsDropdownDataFilter,
      geneDetectionStatus,
      genderFilter,
      clinicalSignificanceFilter,
    ]
  );

  const hospitalCityParams = useMemo(
    () => ({
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
      cancerSite: cancerFilterVal1?.length > 0 ? cancerFilterVal1 : null,
      genes:
        selectedGenes?.length > 0
          ? selectedGenes.map((gene) => gene.biomarkerName)
          : null,
      immunoTherapy:
        immunoFilter?.length > 0
          ? immunoFilter.map((immuno) => immuno.name)
          : null,
      hospitalCity: null,
      hospitalName:
        hospitalsFilter?.length > 0
          ? hospitalsFilter.map((hospital) => hospital.name)
          : null,
      lungsAlliance: lungClicked,
      pdlFilter: isPdlChecked,
      ngsFilterType: ngsValue,
      testNameDetails:
        testTypeFilter?.length > 0
          ? testTypeFilter.map((test) => test.name)
          : null,
      morphologyTypes:
        morphologyFilterVal?.length > 0
          ? morphologyFilterVal.map((morph) => morph.name)
          : null,
      targetedTherapy:
        targetedFilter?.length > 0
          ? targetedFilter.map((targeted) => targeted.name)
          : null,
      doctorsData:
        doctorsDropdownDataFilter?.length > 0
          ? doctorsDropdownDataFilter.map(doctor => doctor.name)
          : null,
      ngsGeneDetectFilter: geneDetectionStatus,
      genderFilter: getGenderParam(genderFilter),
      clinicalSignificanceOfVariance:
        clinicalSignificanceFilter?.length > 0
          ? clinicalSignificanceFilter.map((item) => item.name)
          : null,
    }),

    [
      fromDate,
      toDate,
      cancerFilterVal1,
      selectedGenes,
      immunoFilter,
      hospitalsFilter,
      lungClicked,
      isPdlChecked,
      ngsValue,
      testTypeFilter,
      morphologyFilterVal,
      targetedFilter,
      doctorsDropdownDataFilter,
      geneDetectionStatus,
      genderFilter,
      clinicalSignificanceFilter,
    ]
  );

  const hospitalNameParams = useMemo(
    () => ({
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
      cancerSite: cancerFilterVal1?.length > 0 ? cancerFilterVal1 : null,
      genes:
        selectedGenes?.length > 0
          ? selectedGenes.map((gene) => gene.biomarkerName)
          : null,
      immunoTherapy:
        immunoFilter?.length > 0
          ? immunoFilter.map((immuno) => immuno.name)
          : null,
      hospitalCity:
        citiesFilter?.length > 0 ? citiesFilter.map((city) => city.name) : null,
      hospitalName: null,
      lungsAlliance: lungClicked,
      pdlFilter: isPdlChecked,
      ngsFilterType: ngsValue,
      testNameDetails:
        testTypeFilter?.length > 0
          ? testTypeFilter.map((test) => test.name)
          : null,
      morphologyTypes:
        morphologyFilterVal?.length > 0
          ? morphologyFilterVal.map((morph) => morph.name)
          : null,
      targetedTherapy:
        targetedFilter?.length > 0
          ? targetedFilter.map((targeted) => targeted.name)
          : null,
      doctorsData:
        doctorsDropdownDataFilter?.length > 0
          ? doctorsDropdownDataFilter.map(doctor => doctor.name)
          : null,
      ngsGeneDetectFilter: geneDetectionStatus,
      genderFilter: getGenderParam(genderFilter),
      clinicalSignificanceOfVariance:
        clinicalSignificanceFilter?.length > 0
          ? clinicalSignificanceFilter.map((item) => item.name)
          : null,
    }),

    [
      fromDate,
      toDate,
      cancerFilterVal1,
      selectedGenes,
      immunoFilter,
      citiesFilter,
      lungClicked,
      isPdlChecked,
      ngsValue,
      testTypeFilter,
      morphologyFilterVal,
      targetedFilter,
      doctorsDropdownDataFilter,
      geneDetectionStatus,
      genderFilter,
      clinicalSignificanceFilter,
    ]
  );

  const testNameDetailsParams = useMemo(
    () => ({
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
      cancerSite: cancerFilterVal1?.length > 0 ? cancerFilterVal1 : null,
      genes:
        selectedGenes?.length > 0
          ? selectedGenes.map((gene) => gene.biomarkerName)
          : null,
      immunoTherapy:
        immunoFilter?.length > 0
          ? immunoFilter.map((immuno) => immuno.name)
          : null,
      hospitalCity:
        citiesFilter?.length > 0 ? citiesFilter.map((city) => city.name) : null,
      hospitalName:
        hospitalsFilter?.length > 0
          ? hospitalsFilter.map((hospital) => hospital.name)
          : null,
      lungsAlliance: lungClicked,
      pdlFilter: isPdlChecked,
      ngsFilterType: ngsValue,
      testNameDetails: null,
      morphologyTypes:
        morphologyFilterVal?.length > 0
          ? morphologyFilterVal.map((morph) => morph.name)
          : null,
      targetedTherapy:
        targetedFilter?.length > 0
          ? targetedFilter.map((targeted) => targeted.name)
          : null,
      doctorsData:
        doctorsDropdownDataFilter?.length > 0
          ? doctorsDropdownDataFilter.map(doctor => doctor.name)
          : null,
      ngsGeneDetectFilter: geneDetectionStatus,
      genderFilter: getGenderParam(genderFilter),
      clinicalSignificanceOfVariance:
        clinicalSignificanceFilter?.length > 0
          ? clinicalSignificanceFilter.map((item) => item.name)
          : null,
    }),
    [
      fromDate,
      toDate,
      cancerFilterVal1,
      selectedGenes,
      immunoFilter,
      citiesFilter,
      hospitalsFilter,
      lungClicked,
      isPdlChecked,
      ngsValue,
      morphologyFilterVal,
      targetedFilter,
      doctorsDropdownDataFilter,
      geneDetectionStatus,
      genderFilter,
      clinicalSignificanceFilter,
    ]
  );

  const morphologyTypesParams = useMemo(
    () => ({
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
      cancerSite: cancerFilterVal1?.length > 0 ? cancerFilterVal1 : null,
      genes:
        selectedGenes?.length > 0
          ? selectedGenes.map((gene) => gene.biomarkerName)
          : null,
      immunoTherapy:
        immunoFilter?.length > 0
          ? immunoFilter.map((immuno) => immuno.name)
          : null,
      hospitalCity:
        citiesFilter?.length > 0 ? citiesFilter.map((city) => city.name) : null,
      hospitalName:
        hospitalsFilter?.length > 0
          ? hospitalsFilter.map((hospital) => hospital.name)
          : null,
      lungsAlliance: lungClicked,
      pdlFilter: isPdlChecked,
      ngsFilterType: ngsValue,
      testNameDetails:
        testTypeFilter?.length > 0
          ? testTypeFilter.map((test) => test.name)
          : null,
      morphologyTypes: null,
      targetedTherapy:
        targetedFilter?.length > 0
          ? targetedFilter.map((immuno) => immuno.name)
          : null,
      doctorsData:
        doctorsDropdownDataFilter?.length > 0
          ? doctorsDropdownDataFilter.map(doctor => doctor.name)
          : null,
      ngsGeneDetectFilter: geneDetectionStatus,
      genderFilter: getGenderParam(genderFilter),
      clinicalSignificanceOfVariance:
        clinicalSignificanceFilter?.length > 0
          ? clinicalSignificanceFilter.map((item) => item.name)
          : null,
    }),
    [
      fromDate,
      toDate,
      cancerFilterVal1,
      selectedGenes,
      immunoFilter,
      citiesFilter,
      hospitalsFilter,
      lungClicked,
      isPdlChecked,
      ngsValue,
      testTypeFilter,
      targetedFilter,
      doctorsDropdownDataFilter,
      geneDetectionStatus,
      genderFilter,
      clinicalSignificanceFilter,
    ]
  );

  const targetedTherapyParams = useMemo(
    () => ({
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
      cancerSite: cancerFilterVal1?.length > 0 ? cancerFilterVal1 : null,
      genes:
        selectedGenes?.length > 0
          ? selectedGenes.map((gene) => gene.biomarkerName)
          : null,
      immunoTherapy:
        immunoFilter?.length > 0
          ? immunoFilter.map((immuno) => immuno.name)
          : null,
      hospitalCity:
        citiesFilter?.length > 0 ? citiesFilter.map((city) => city.name) : null,
      hospitalName:
        hospitalsFilter?.length > 0
          ? hospitalsFilter.map((hospital) => hospital.name)
          : null,
      lungsAlliance: lungClicked,
      pdlFilter: isPdlChecked,
      ngsFilterType: ngsValue,
      testNameDetails:
        testTypeFilter?.length > 0
          ? testTypeFilter.map((test) => test.name)
          : null,
      morphologyTypes:
        morphologyFilterVal?.length > 0
          ? morphologyFilterVal.map((morph) => morph.name)
          : null,
      targetedTherapy: null,
      doctorsData:
        doctorsDropdownDataFilter?.length > 0
          ? doctorsDropdownDataFilter.map(doctor => doctor.name)
          : null,
      ngsGeneDetectFilter: geneDetectionStatus,
      genderFilter: getGenderParam(genderFilter),
      clinicalSignificanceOfVariance:
        clinicalSignificanceFilter?.length > 0
          ? clinicalSignificanceFilter.map((item) => item.name)
          : null,
    }),
    [
      fromDate,
      toDate,
      cancerFilterVal1,
      selectedGenes,
      citiesFilter,
      hospitalsFilter,
      lungClicked,
      isPdlChecked,
      ngsValue,
      testTypeFilter,
      morphologyFilterVal,
      immunoFilter,
      doctorsDropdownDataFilter,
      geneDetectionStatus,
      genderFilter,
      clinicalSignificanceFilter,
    ]
  );
  const doctorFilterParams = useMemo(
    () => ({
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
      cancerSite: cancerFilterVal1?.length > 0 ? cancerFilterVal1 : null,
      genes:
        selectedGenes?.length > 0
          ? selectedGenes.map((gene) => gene.biomarkerName)
          : null,
      immunoTherapy:
        immunoFilter?.length > 0
          ? immunoFilter.map((immuno) => immuno.name)
          : null,
      hospitalCity:
        citiesFilter?.length > 0 ? citiesFilter.map((city) => city.name) : null,
      hospitalName:
        hospitalsFilter?.length > 0
          ? hospitalsFilter.map((hospital) => hospital.name)
          : null,
      lungsAlliance: lungClicked,
      pdlFilter: isPdlChecked,
      ngsFilterType: ngsValue,
      testNameDetails:
        testTypeFilter?.length > 0
          ? testTypeFilter.map((test) => test.name)
          : null,
      morphologyTypes:
        morphologyFilterVal?.length > 0
          ? morphologyFilterVal.map((morph) => morph.name)
          : null,
      targetedTherapy:
        targetedFilter?.length > 0
          ? targetedFilter.map((immuno) => immuno.name)
          : null,
      doctorsData: null,
      ngsGeneDetectFilter: geneDetectionStatus,
      genderFilter: getGenderParam(genderFilter),
      clinicalSignificanceOfVariance:
        clinicalSignificanceFilter?.length > 0
          ? clinicalSignificanceFilter.map((item) => item.name)
          : null,
    }),
    [
      fromDate,
      toDate,
      geneDetectionStatus,
      cancerFilterVal1,
      selectedGenes,
      citiesFilter,
      hospitalsFilter,
      lungClicked,
      isPdlChecked,
      ngsValue,
      morphologyFilterVal,
      immunoFilter,
      targetedFilter,
      testTypeFilter,
      genderFilter,
      clinicalSignificanceFilter,
    ]
  );
  
  const clinicalsignificanceFilterParams = useMemo(
    () => ({
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
      cancerSite: cancerFilterVal1?.length > 0 ? cancerFilterVal1 : null,
      genes:
        selectedGenes?.length > 0
          ? selectedGenes.map((gene) => gene.biomarkerName)
          : null,
      immunoTherapy:
        immunoFilter?.length > 0
          ? immunoFilter.map((immuno) => immuno.name)
          : null,
      hospitalCity:
        citiesFilter?.length > 0 ? citiesFilter.map((city) => city.name) : null,
      hospitalName:
        hospitalsFilter?.length > 0
          ? hospitalsFilter.map((hospital) => hospital.name)
          : null,
      lungsAlliance: lungClicked,
      pdlFilter: isPdlChecked,
      ngsFilterType: ngsValue,
      testNameDetails:
        testTypeFilter?.length > 0
          ? testTypeFilter.map((test) => test.name)
          : null,
      morphologyTypes:
        morphologyFilterVal?.length > 0
          ? morphologyFilterVal.map((morph) => morph.name)
          : null,
      targetedTherapy:
        targetedFilter?.length > 0
          ? targetedFilter.map((targeted) => targeted.name)
          : null,
      doctorsData:
        doctorsDropdownDataFilter?.length > 0
          ? doctorsDropdownDataFilter.map((doctor) => doctor.name)
          : null,
      ngsGeneDetectFilter: geneDetectionStatus,
      genderFilter: getGenderParam(genderFilter),
      clinicalSignificanceOfVariance: null,
    }),
    [
      fromDate,
      toDate,
      cancerFilterVal1,
      selectedGenes,
      immunoFilter,
      citiesFilter,
      hospitalsFilter,
      lungClicked,
      isPdlChecked,
      ngsValue,
      morphologyFilterVal,
      targetedFilter,
      doctorsDropdownDataFilter,
      geneDetectionStatus,
      testTypeFilter,
      genderFilter,
    ]
  );

  const genderFilterParams = useMemo(
    () => ({
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
      cancerSite: cancerFilterVal1?.length > 0 ? cancerFilterVal1 : null,
      genes:
        selectedGenes?.length > 0
          ? selectedGenes.map((gene) => gene.biomarkerName)
          : null,
      immunoTherapy:
        immunoFilter?.length > 0
          ? immunoFilter.map((immuno) => immuno.name)
          : null,
      hospitalCity:
        citiesFilter?.length > 0 ? citiesFilter.map((city) => city.name) : null,
      hospitalName:
        hospitalsFilter?.length > 0
          ? hospitalsFilter.map((hospital) => hospital.name)
          : null,
      lungsAlliance: lungClicked,
      pdlFilter: isPdlChecked,
      ngsFilterType: ngsValue,
      testNameDetails:
        testTypeFilter?.length > 0
          ? testTypeFilter.map((test) => test.name)
          : null,
      morphologyTypes:
        morphologyFilterVal?.length > 0
          ? morphologyFilterVal.map((morph) => morph.name)
          : null,
      targetedTherapy:
        targetedFilter?.length > 0
          ? targetedFilter.map((targeted) => targeted.name)
          : null,
      doctorsData:
        doctorsDropdownDataFilter?.length > 0
          ? doctorsDropdownDataFilter.map((doctor) => doctor.name)
          : null,
      ngsGeneDetectFilter: geneDetectionStatus,
      clinicalSignificanceOfVariance:
        clinicalSignificanceFilter?.length > 0
          ? clinicalSignificanceFilter.map((item) => item.name)
          : null,
    }),
    [
      fromDate,
      toDate,
      cancerFilterVal1,
      selectedGenes,
      immunoFilter,
      citiesFilter,
      hospitalsFilter,
      lungClicked,
      isPdlChecked,
      ngsValue,
      morphologyFilterVal,
      targetedFilter,
      doctorsDropdownDataFilter,
      geneDetectionStatus,
      testTypeFilter,
      clinicalSignificanceFilter
    ]
  );

  useEffect(() => {
    CancerSitesAPICall();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [
    cancerFilterVal1,
    selectedGenes,
    immunoFilter,
    targetedFilter,
    citiesFilter,
    hospitalsFilter,
    lungClicked,
    isPdlChecked,
    ngsValue,
    testTypeFilter,
    morphologyFilterVal,
    doctorsDropdownDataFilter,
    geneDetectionStatus,
    genderFilter,
    clinicalSignificanceFilter,
    geneDetectionStatus
  ]);

  useEffect(() => {
    if (fromDate && toDate) {
      CancerSitesAPICall();
    } else if (!fromDate && !toDate) {
      CancerSitesAPICall();
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [fromDate, toDate]);

  function transsData(array) {
    const newarr = array?.map((item) => ({
      name: item[0] || null,
      value: item[1],
    }));
    return newarr;
  }


  function transsDataV1(array) {
    const newarr = array?.map((item) => ({
      name: item.drugName,
      value: item.count,
    }));
    return newarr;
  }

  function Agegender(array) {
    if (!Array.isArray(array)) return [];

    const newarr = array.map((item) => {
      const ageGroup = item?.ageGroup;

      let sortKey = 0;
      if (ageGroup.includes("+")) {
        sortKey = parseInt(ageGroup.replace("+", ""), 10);
      } else if (ageGroup.includes("-")) {
        sortKey = parseInt(ageGroup.split("-")[0], 10);
      }

      return {
        ageGroup,
        Male: item?.maleCount,
        Female: item?.femaleCount,
        sortKey,
      };
    });

    return newarr
      .filter((item) => item.Male !== 0 || item.Female !== 0)
      .sort((a, b) => a.sortKey - b.sortKey)
      .map(({ sortKey, ...rest }) => rest);
  }

  function immunoTherapyResponse(data) {
    const immunoTherapyData = transsDataV1(data?.payLoad);
    const sortedData10 = immunoTherapyData?.sort((a, b) => b.value - a.value);
    setDrugsCount(sortedData10);
    const DrugsCountTotal = data.payLoad?.reduce(
      (accumulator, currentValue) => accumulator + currentValue.count,
      initialValue
    );
    setDrugsCountTotal(DrugsCountTotal);
  }
  function targetedTherapyResponse(data) {
    const targetedTherapyData = transsDataV1(data?.payLoad);
    const sortedData10 = targetedTherapyData?.sort((a, b) => b.value - a.value);
    setTargetedTherapy(sortedData10);
    const DrugsCountTotal = data.payLoad?.reduce(
      (accumulator, currentValue) => accumulator + currentValue.count,
      initialValue
    );
    setTargetedTherapyTotal(DrugsCountTotal);
  }
  function drugDataChange(array) {
    const newState = array?.map((obj) => {
      if (obj?.name === "CHEMOTHERAPY") {
        return { ...obj, name: "Chemotherapy" };
      } else if (obj?.name === "DRUG_THERAPY") {
        return { ...obj, name: "Hormonal Therapy" };
      } else if (obj?.name === "IMMUNOTHERAPY") {
        return { ...obj, name: "Biological Therapy" };
      }
      return obj;
    });
    return newState;
  }
  function CancerDataChange(array) {
    const newState = array?.map((obj) => {
      if (obj?.name === "Patients with no cancer site") {
        return { ...obj, name: "Asymptomatic" };
      }
      return obj;
    });
    return newState;
  }
  function treatmentDataChange(array) {
    const newState = array?.map((obj) => {
      if (obj?.name === "Drugs Therapy") {
        return { ...obj, name: "Systemic Therapy" };
      } else if (obj?.name === "Radiation") {
        return { ...obj, name: "Radiation Therapy" };
      } else if (obj?.name === "Surgery") {
        return { ...obj, name: "Surgery Therapy" };
      }
      return obj;
    });
    return newState;
  }
  function biologicalDataChange(array) {
    const newState = array?.map((obj) => {
      if (obj?.name === "Targeted therapy") {
        return { ...obj, name: "Targeted Therapy" };
      } else if (obj?.name === "Immunotherapy") {
        return { ...obj, name: "Immuno Therapy" };
      }
      return obj;
    });
    return newState;
  }
  function tmbmsipdlDataChange(array) {
    const newState = array?.map((obj) => {
      if (obj?.name === "NULL") {
        return { ...obj, name: "Not Tested" };
      }
      return obj;
    });
    return newState;
  }
  function combineMsiBorderline(data) {
    if (!data) return data;

    const combinedData = [];

    let stableTotal = 0;

    for (const item of data) {
      if (item.name === "Stable" || item.name === "Borderline") {
        stableTotal += item.value;
      } else {
        combinedData.push(item);
      }
    }
    
    combinedData.push({ name: "Stable", value: stableTotal });
    
    return combinedData;
  }
  function combineMissense(data) {
    const combinedData = [];

    let missenseTotal = 0;

    for (const item of data) {
      if (item.name === "Missense" || item.name === "Missense Mutation") {
        missenseTotal += item.value;
      } else {
        combinedData.push(item);
      }
    }

    if (missenseTotal > 0) {
      combinedData.push({ name: "Missense", value: missenseTotal });
    }

    return combinedData;
  }
  const CancerSitesAPICall = async () => {
    setCancerSitesLoader(true);

    try {
      const patientCountRes = await apiCall(
        "POST",
        ApiEndPoint.patientCount,
        params
      );
      setTotalValue(patientCountRes?.data?.payLoad);

      const primarySiteRes = await apiCall(
        "POST",
        ApiEndPoint.primaryCancersite,
        params
      );
      setPrimarySite(primarySiteRes?.data?.payLoad);

      const noCancerSiteRes = await apiCall(
        "POST",
        ApiEndPoint.no_cancer_site_patients,
        params
      );
      const noCancerDataRaw = transsData(noCancerSiteRes?.data?.payLoad);
      const noCancerData = CancerDataChange(noCancerDataRaw);
      const isValidNoCancerData =
        Array.isArray(noCancerData) &&
        noCancerData.some((item) => item.value !== 0 && item.value !== null);

      const top10Res = await apiCall(
        "POST",
        ApiEndPoint.MajorTop10Cancersite,
        params
      );
      const top10Data = transsData(top10Res?.data?.payLoad);
      const combinedData = isValidNoCancerData
        ? [...top10Data, ...noCancerData]
        : [...top10Data];

      const sortedCombinedData = combinedData.sort((a, b) => b.value - a.value);
      const top10Sorted = sortedCombinedData.slice(0, 10);
      const remainingFromTopCombined = sortedCombinedData.slice(10);
      if (cancerFilterVal1?.length > 0) {
        const filterNames = cancerFilterVal1.map((f) => f.name || f);
        const filtered = top10Sorted.filter((item) =>
          filterNames.includes(item.name)
        );
        const top10Total = filtered.reduce(
        (acc, curr) => acc + curr.value,
        initialValue
        );
        setTop10TotalCount(top10Total);
        setCancerSiteTop10(filtered);
      } else {
      const top10Total = top10Sorted.reduce(
        (acc, curr) => acc + curr.value,
        initialValue
      );
      setTop10TotalCount(top10Total);
      setCancerSiteTop10(top10Sorted);
      }


      const [restRes, restRes1] = await Promise.all([
        apiCall("POST", ApiEndPoint.CancersiteDistribution, params),
        apiCall("POST", ApiEndPoint.CancersiteDistribution, cancerSiteparams),
      ]);

      const restData = transsData(restRes?.data?.payLoad).slice(10);
      const allCancerSites = transsData(restRes1?.data?.payLoad);
      const combined = [...restData, ...remainingFromTopCombined];

      const finalRestData = Array.from(new Map(combined.map(item => [item.name, item])).values())
        .filter((item) => item.value !== 0 && item.value !== null)
        .sort((a, b) => b.value - a.value);
      setCancerSiteRestOf(finalRestData);
      const restTotal = finalRestData.reduce(
        (acc, curr) => acc + curr.value,
        initialValue
      );
      setTotalCount(restTotal);
const sortedDropdown = allCancerSites.sort((a, b) =>
  a.name.localeCompare(b.name)
);
const staticSiteNames = new Set(
  cancerGroups.flatMap((group) => group.sites.map((s) => s.toLowerCase()))
);
let groupedCancerData = cancerGroups
  .map((group) => {
    const matchedSites = group.sites
      .map((site) => {
        const found = sortedDropdown.find(
          (c) => c.name.toLowerCase() === site.toLowerCase()
        );
        return { name: site, value: found ? found.value : 0 };
      })
      .filter((site) => site.value > 0 || site.value === 1)
      .sort((a, b) => b.value - a.value); // Sort sites within each group

    const total = matchedSites.reduce((acc, s) => acc + s.value, 0);
    return { ...group, total, matchedSites };
  })
  .sort((a, b) => b.total - a.total); // Sort groups by total in descending order
const unmatchedSites = sortedDropdown.filter(
  (item) => !staticSiteNames.has(item.name.toLowerCase())
);
if (unmatchedSites.length > 0) {
  const otherGroupIndex = groupedCancerData.findIndex(
    (g) => g.name.toLowerCase() === "other sites"
  );

  if (otherGroupIndex !== -1) {
    groupedCancerData[otherGroupIndex].matchedSites.push(...unmatchedSites);
    groupedCancerData[otherGroupIndex].matchedSites.sort((a, b) => b.value - a.value); // Sort after adding
    groupedCancerData[otherGroupIndex].total += unmatchedSites.reduce(
      (acc, s) => acc + s.value,
      0
    );
  } else {
    groupedCancerData.push({
      name: "Other sites",
      sites: unmatchedSites.map((s) => s.name),
      matchedSites: unmatchedSites.sort((a, b) => b.value - a.value), // Sort before adding
      total: unmatchedSites.reduce((acc, s) => acc + s.value, 0),
    });
  }
}
groupedCancerData.sort((a, b) => b.total - a.total);
groupedCancerData = groupedCancerData.filter(
  (group) => group.matchedSites && group.matchedSites.length > 0
);
setCancerDropdown(groupedCancerData);

      SomaticGermlineAPICall();
      BiomarkersAPICall();
      // Only fetch TMB/MSI/PDL when NOT viewing the 1K Dashboard
      if (!is1kViewEnabled) {
        TmbMsiPdlAPICall();
      }
      TreatmentDetailsAPICall();
      DrugTherapyAPICall();
      GenderAgeDistrubtutionAPICall();
      HospitalAPICall();
      morphologyDataAPICall();
      fetchTestTypeData();
      doctorsDataApiCall();
      testTypesFilterAPI();
      clinicalSignificanceFilterAPI();
    } catch (error) {
      console.error("Section 1 API Call Error:", error);
    } finally {
      setCancerSitesLoader(false);
    }
  };
  const SomaticGermlineAPICall = async () => {
    setMorphologySomaticGermlineLoader(true);
    try {
      const somaticRes = await apiCall(
        "POST",
        ApiEndPoint.SomaticGermline,
        params
      );
      let somaticData = somaticRes?.data?.payLoad
        ?.slice()
        ?.sort((a, b) => b.value - a.value);

      somaticData = somaticData.map((item) => {
        const updatedCategoryList = item.categoryList.map((cat) => ({
          ...cat,
          category: cat.category === "Solid+Liquid" ? "SoLiQ" : cat.category,
        }));
        return {
          ...item,
          categoryList: updatedCategoryList,
        };
      });
      setSomaticGermline(somaticData);

      setSomaticTotal(
        somaticData?.reduce((acc, curr) => acc + curr.value, initialValue)
      );

      const variantRes = await apiCall(
        "POST",
        ApiEndPoint.variantTypeResponse,
        params
      );
      const variantData = transsData(variantRes?.data?.payLoad);
      const variantData1 = combineMissense(variantData);
      setVariantTypeResponse(variantData1?.sort((a, b) => b.value - a.value));
      setVariantTypeTotal(
        variantData?.reduce((acc, curr) => acc + curr.value, initialValue)
      );
    } catch (error) {
      console.error("error:", error);
    } finally {
      setMorphologySomaticGermlineLoader(false);
    }
  };

  const BiomarkersAPICall = async () => {
    setBiomarkersLoader(true);
    try {
      const biomarkersRes = await apiCall(
        "POST",
        ApiEndPoint.BioMarkers,
        params
      );
      const biomarkersRes1 = await apiCall(
        "POST",
        ApiEndPoint.BioMarkers,
        genesParams
      );

      const processBiomarkers = (payload) => {
        return payload?.map((b) => {
          if (b.biomarkerName?.trim()?.toLowerCase() === "no clinically relevant mutations detected") {
            return { ...b, biomarkerName: "NCRMD" };
          }
          return b;
        });
      };

      const processedPayloadRes = processBiomarkers(biomarkersRes?.data?.payLoad);

      const topBiomarkers = processedPayloadRes
        ?.slice()
        ?.sort((a, b) => b.totalCancerSiteCount - a.totalCancerSiteCount)
        ?.slice(0, 20);
      const uniqueCancerSiteNames = Array.from(
        new Set(
          topBiomarkers?.flatMap((stage) =>
            stage.cancerSiteCountList.map((site) => site.cancerSiteName)
          )
        )
      );
      const colorMapping = uniqueCancerSiteNames?.reduce((acc, name, index) => {
        acc[name] = biomarkercolors[index % biomarkercolors.length];
        return acc;
      }, {});
      const allCancerSites = uniqueCancerSiteNames?.map((name) => ({
        dataKey: name,
        fill: colorMapping[name],
      }));

      const sortedBiomarkers = topBiomarkers?.map((biomarker) => {
        const siteEntries = biomarker.cancerSiteCountList
          .slice()
          .sort((a, b) => b.cancerSiteCount - a.cancerSiteCount);

        return {
          biomarkerName: biomarker.biomarkerName,
          totalCancerSiteCount: biomarker.totalCancerSiteCount,
          sortedSites: siteEntries,
        };
      });
      setColorMapping(colorMapping);
      setCansiteName(allCancerSites);
      setGeneCancer(sortedBiomarkers);
      const sortedGeneCancerAllDataList = biomarkersRes1?.data?.payLoad
        ?.slice()
        ?.sort((a, b) => b.totalCancerSiteCount - a.totalCancerSiteCount);
      setGeneCancerAllDataList(sortedGeneCancerAllDataList);
    } catch (error) {
      console.error("error:", error);
    } finally {
      setBiomarkersLoader(false);
    }
  };

  const TmbMsiPdlAPICall = async () => {
    setTmbMsiPdlLoader(true);
    try {
      const tmbRes = await apiCall("POST", ApiEndPoint.TMB, params);
      const tmbData = tmbmsipdlDataChange(transsData(tmbRes?.data?.payLoad));
      setTmbData(tmbData?.sort((a, b) => b.value - a.value));
      setTmbTotal(
        tmbData?.reduce((acc, curr) => acc + curr.value, initialValue)
      );

      const msiRes = await apiCall("POST", ApiEndPoint.MSI, params);
      const msiData = combineMsiBorderline(
        tmbmsipdlDataChange(transsData(msiRes?.data?.payLoad))
      );
      setMsiData(msiData?.sort((a, b) => b.value - a.value));
      setMsiTotal(
        msiData?.reduce((acc, curr) => acc + curr.value, initialValue)
      );

      const pdlRes = await apiCall("POST", ApiEndPoint.PDL, params);
      const pdlData = tmbmsipdlDataChange(transsData(pdlRes?.data?.payLoad));
      setPdlData(pdlData?.sort((a, b) => b.value - a.value));
      setPdlTotal(
        pdlData?.reduce((acc, curr) => acc + curr.value, initialValue)
      );
    } catch (error) {
      console.error("error:", error);
    } finally {
      setTmbMsiPdlLoader(false);
    }
  };

  const TreatmentDetailsAPICall = async () => {
    setTreatmentDetailsLoader(true);
    try {
      const treatmentRes = await apiCall(
        "POST",
        ApiEndPoint.TreatmentDistribution,
        params
      );
      const treatmentData = transsData(treatmentRes?.data?.payLoad);
      setTreatmentDetails(
        treatmentDataChange(treatmentData?.sort((a, b) => b.value - a.value))
      );
      setTreatmentsTotal(
        treatmentData?.reduce((acc, curr) => acc + curr.value, initialValue)
      );

      const drugRes = await apiCall(
        "POST",
        ApiEndPoint.SystematicDrugTherapy,
        params
      );
      const drugData = transsData(drugRes?.data?.payLoad);
      setDrugTherapy(
        drugDataChange(drugData?.sort((a, b) => b.value - a.value))
      );
      setDrugTotal(
        drugData?.reduce((acc, curr) => acc + curr.value, initialValue)
      );

      const biologicalRes = await apiCall(
        "POST",
        ApiEndPoint.BiologicalTherapy,
        params
      );
      const biologicalData = transsData(biologicalRes?.data?.payLoad);
      setBiologicalTherapy(
        biologicalDataChange(biologicalData?.sort((a, b) => b.value - a.value))
      );
      setBiologicalTotal(
        biologicalData?.reduce((acc, curr) => acc + curr.value, initialValue)
      );
    } catch (error) {
    } finally {
      setTreatmentDetailsLoader(false);
    }
  };

  const DrugTherapyAPICall = async () => {
    try {
      setDrugTherapyLoader(true);
      // Get immunotherapy drugs data for the chart
      const immunoRes = await apiCall(
        "POST",
        ApiEndPoint.ImmonotherapyDrugs,
        params
      );
      immunoTherapyResponse(immunoRes?.data);
      //Targeted therapy drugs data for the chart
      const targetedRes = await apiCall(
        "POST",
        ApiEndPoint.targeted_therapy_drug,
        params
      );
      targetedTherapyResponse(targetedRes?.data);

      // Get immunotherapy drugs list for the filter
      const immunoFilterRes = await apiCall(
        "POST",
        ApiEndPoint.immuno_dropdown,
        immunoTherapyParams
      );
      const targetedFilterRes = await apiCall(
        "POST",
        ApiEndPoint.targeted_therapy_filter,
        targetedTherapyParams
      );

      const transformedDrugs = immunoFilterRes?.data?.payLoad?.map((drug) => ({
        name: drug[0],
        value: drug[1],
      }));
      const transformedTargetedDrugs = targetedFilterRes?.data?.payLoad?.map((drug) => ({
        name: drug[0],
        value: drug[1],
      }));

      setImmunoFilterData(transformedDrugs?.sort((a, b) => b.value - a.value));
      setTargetedFilterData(
        transformedTargetedDrugs?.sort((a, b) => b.value - a.value)
      );

      const treatmentResponse = await apiCall(
        "POST",
        ApiEndPoint.TreatmentResponse,
        params
      );

      const recistData = transsData(treatmentResponse?.data?.payLoad);

      setRecistCriteria(recistData?.sort((a, b) => b.value - a.value));
      setRecistCriteriaTotal(
        treatmentResponse?.data?.payLoad?.reduce(
          (acc, curr) => acc + curr[1],
          initialValue
        )
      );
    } catch (error) {
      console.error("Error in DrugTherapyAPICall:", error);
    } finally {
      setDrugTherapyLoader(false);
    }
  };

  const GenderAgeDistrubtutionAPICall = async () => {
    try {
      setGenderAgeDistrubtutionLoader(true);
      const ageGenderRes = await apiCall(
        "POST",
        ApiEndPoint.GendervsAge,
        params
      );
      const agegender = Agegender(ageGenderRes?.data?.payLoad);
      const filteredAgeGender = agegender?.filter((item) => {
        const ageRange = item.ageGroup;
        if (/^\d+-\d+$/.test(ageRange)) {
          const upperBound = parseInt(ageRange.split("-")[1], 10);
          return upperBound <= 100;
        }
        return false;
      });
      setGenderAgeGroup(filteredAgeGender);
      const cancerStageRes = await apiCall(
        "POST",
        ApiEndPoint.cancer_stage_details,
        params
      );
      const cancerStageData = transsData(cancerStageRes?.data?.payLoad);
      setCancerStage(cancerStageData?.sort((a, b) => b.value - a.value));
      setCancerStageTotal(
        cancerStageData?.reduce((acc, curr) => acc + curr.value, initialValue)
      );
    } catch (error) {
    } finally {
      setGenderAgeDistrubtutionLoader(false);
    }
  };

  const HospitalAPICall = async () => {
    setHospitalTestTypeLoader(true);
    try {
      const hospitalCitiesRes = await apiCall(
        "POST",
        ApiEndPoint.hospital_city_dropdown,
        hospitalCityParams
      );
      const transformedCities = hospitalCitiesRes?.data?.payLoad?.map(
        (city) => ({
          name: city[0],
          value: city[1],
        })
      );
      setCitiesFilterData(transformedCities?.sort((a, b) => b.value - a.value));

      const hospitalsRes = await apiCall(
        "POST",
        ApiEndPoint.hospital_name_dropdown,
        hospitalNameParams
      );
      const transformedHospitals = hospitalsRes?.data?.payLoad?.map(
        (hospital) => ({
          name: hospital[0],
          value: hospital[1],
        })
      );
      setHospitalsFilterData(
        transformedHospitals?.sort((a, b) => b.value - a.value)
      );

      // Get city data
      const hospitalRes = await apiCall(
        "POST",
        ApiEndPoint.hospital_city_details,
        params
      );
      const cityDataRaw = hospitalRes?.data?.payLoad || [];

      const cityData = cityDataRaw.map(([city, value]) => ({
        label: city,
        value,
      }));

      const sortedCityData = cityData.sort((a, b) => b.value - a.value);
      const totalCityValue = cityData.reduce(
        (acc, curr) => acc + curr.value,
        0
      );

      setHospitalCityData(sortedCityData);
      setHospitalCityTotal(totalCityValue);

      const proteinRes = await apiCall(
        "POST",
        ApiEndPoint.protein_change_details,
        params
      );

      const rawPayload = proteinRes?.data?.payLoad;

      const updatedProteinChangeDetails = rawPayload?.map((item) => {
        const newItem = {
          ...item,
          proteinChangeCountList: [...(item.proteinChangeCountList || [])].sort((a,b) =>
              b.proteinChangeCount - a.proteinChangeCount),
        };
        return newItem;
      });
      const sortedGenes = [...(updatedProteinChangeDetails || [])].sort((a, b) =>
              b.totalProteinChangeCount - a.totalProteinChangeCount).slice(0, 10);
              setProteinChangeDetails(sortedGenes);
      // Get hospital data for each city
      const hospitalDataByCity = {};

      // First get data for index 0
      if (sortedCityData.length > 0) {
        const firstCityData = sortedCityData[0];
        const firstCityName = firstCityData.label;
        const firstHospitalRes = await apiCall(
          "POST",
          ApiEndPoint.hospital_name_details_by_city.replace(
            "{hospitalCity}",
            encodeURIComponent(firstCityName)
          ),
          params
        );

        if (firstHospitalRes?.data?.payLoad) {
          hospitalDataByCity[firstCityName] = firstHospitalRes.data.payLoad.map(
            ([name, count]) => ({
              name,
              count,
            })
          );
        }
        setHospitalNameData(hospitalDataByCity);

        // Get remaining cities with delay
        setTimeout(async () => {
          for (let i = 1; i < sortedCityData.length; i++) {
            const cityData = sortedCityData[i];
            const cityName = cityData.label;
            const hospitalNameRes = await apiCall(
              "POST",
              ApiEndPoint.hospital_name_details_by_city.replace(
                "{hospitalCity}",
                encodeURIComponent(cityName)
              ),
              params
            );

            if (hospitalNameRes?.data?.payLoad) {
              hospitalDataByCity[cityName] = hospitalNameRes.data.payLoad.map(
                ([name, count]) => ({
                  name,
                  count,
                })
              );
            }
          }
          setHospitalNameData({ ...hospitalDataByCity });
        }, 3000);
      }
    } catch (error) {
      console.error("Error in HospitalAPICall:", error);
    } finally {
      setHospitalTestTypeLoader(false);
    }
  };

  const morphologyDataAPICall = async () => {
    setMorphologyDataLoader(true);
    try {
      const morphologyRes = await apiCall(
        "POST",
        ApiEndPoint.morphology_details,
        params
      );
      const morphologyDropDownRes = await apiCall(
        "POST",
        ApiEndPoint.morphology_details,
        morphologyTypesParams
      );
      const rawData = morphologyRes?.data?.payLoad || [];

      // Transform for chart
      const transformedData = transsData(rawData);

      setMorphologyData(transformedData);

      // Total count
      setMorphTotalCount(
        transformedData.reduce((acc, curr) => acc + (curr.value || 0), 0)
      );
      // Sorted dropdown list
      const sortedDropdown =
        transsData(morphologyDropDownRes?.data?.payLoad) || [];
      setMorphologyDropdown(sortedDropdown);
    } catch (error) {
      console.error("Morphology API Error:", error);
    } finally {
      setMorphologyDataLoader(false);
    }
  };
  const fetchTestTypeData = useCallback(async () => {
    setTestTypeGraphLoader(true);

    let updatedParams = {};
    Object.keys(params).forEach((param) => {
      if (params[param] !== null) {
        updatedParams[param] = params[param];
      }
    });

    try {
      const testTypeGraphApiRes = await apiClient(
        "GET",
        ApiEndPoint.getTestTypeGraph,
        updatedParams
      );

      const rawData = testTypeGraphApiRes || [];
      // Transform for chart
      const transformedData = TransformRawObjectData(rawData?.payLoad);
      setTestTypeGraphData(transformedData);

      // Total count
      setTestTypeTotalCount(
        transformedData.reduce((acc, curr) => acc + (curr.value || 0), 0)
      );
    } catch (error) {
      console.error("Test Type API Error:", error);
    } finally {
      setTestTypeGraphLoader(false);
    }
  }, [params]);


  const testTypesFilterAPI = useCallback(async () => {
    const updatedParams = {};
    Object.keys(testNameDetailsParams).forEach((key) => {
      const value = testNameDetailsParams[key];
      if (value !== null && value !== undefined) {
        updatedParams[key] = value;
      }
    });

    try {
      const testTypeDropdownRes = await apiClient(
        "GET",
        ApiEndPoint.getTestTypeGraph,
        updatedParams
      );
      const rawData = testTypeDropdownRes || [];
      const transformedData = TransformRawObjectData(rawData?.payLoad);
      setTestTypeFilterData(transformedData);
    } catch (error) {
      console.error("test type filter drop down API Error:", error);
      setTestTypeFilterData([]);
    }
  }, [testNameDetailsParams]);


  const genderFilterAPI = useCallback(async () => {
  try {
    const updatedParams = {};
    Object.keys(genderFilterParams).forEach((key) => {
      const value = genderFilterParams[key];
      if (value !== null && value !== undefined) {
        updatedParams[key] = value;
      }
    });
    

      const res = await apiClient(
        "POST",
        ApiEndPoint.genderList,
        {},
        {},
        updatedParams
      );

      const raw = res?.payLoad || {};
      // API returns object → convert to array
      const transformed = Object.entries(raw).map(([name, value]) => ({
        name,
        value
      }));

      setGenderDropdown(transformed);

    } catch (err) {
      console.error("gender dropdown error", err);
      setGenderDropdown([]);
    }
  }, [genderFilterParams, setGenderDropdown]);

  useEffect(() => {
    genderFilterAPI();
  }, [genderFilter, genderFilterAPI]);

  const clinicalSignificanceFilterAPI = useCallback(async () => {
    const updatedParams = {};
    Object.keys(clinicalsignificanceFilterParams).forEach((key) => {
      const value = clinicalsignificanceFilterParams[key];
      if (value !== null && value !== undefined) {
        updatedParams[key] = value;
      }
    });

    try {
      const clinicalDropdownRes = await apiClient(
        "GET",
        ApiEndPoint.clinical_significance,
        updatedParams
      );
      const rawData = clinicalDropdownRes || [];
      const transformedData = TransformRawObjectData(rawData?.payLoad);
      const normalizedData = normalizeClinicalSignificanceData(transformedData);

      setClinicalSignificanceDropdown(normalizedData);
    } catch (error) {
      console.error("clinical API Error:", error);
      setClinicalSignificanceDropdown([]);
    }
  }, [clinicalsignificanceFilterParams]);

  const clinicalSignificanceTotal = useMemo(() => {
    return clinicalSignificanceDropdown?.reduce(
      (sum, item) => sum + (item.value || 0),
      0
    );
  }, [clinicalSignificanceDropdown]);

  const doctorsDataApiCall = useCallback(async () => {
    const updatedParams = {};
    Object.keys(doctorFilterParams).forEach((key) => {
      const value = doctorFilterParams[key];
      if (value !== null && value !== undefined) {
        updatedParams[key] = value;
      }
    });

    try {
      const doctorDropdownRes = await apiClient(
        "GET",
        ApiEndPoint.doctors_dropdown_data,
        updatedParams
      );
      const rawData = doctorDropdownRes || [];
      // Ensure we always set an array
      const transformedData = TransformRawObjectData(rawData?.payLoad);
      setDoctorsDropdownData(transformedData.sort((a, b) => b.value - a.value));
    } catch (error) {
      console.error("Doctor API Error:", error);
      setDoctorsDropdownData([]); // fallback to empty array
    }
  }, [doctorFilterParams]);

  return (
    <>
      <Dashboard
        filterVal={filterVal}
        cancerFilterVal={cancerFilterVal}
        totalCount={totalCount}
        genderAgeGroup={genderAgeGroup}
        tmbData={tmbData}
        msiData={msiData}
        pdlData={pdlData}
        treatmentDetails={treatmentDetails}
        drugTherapy={drugTherapy}
        biologicalTherapy={biologicalTherapy}
        cancerSiteRestOfData={cancerSiteRestOfData}
        cancerSiteTop10Data={cancerSiteTop10Data}
        top10totalCount={top10totalCount}
        IsLoading={IsLoading}
        totalValue={totalValue}
        primarySite={primarySite}
        tmbTotal={tmbTotal}
        msiTotal={msiTotal}
        pdlTotal={pdlTotal}
        morphTotalCount={morphTotalCount}
        testTypeTotalCount={testTypeTotalCount}
        treatmentsTotal={treatmentsTotal}
        drugTotal={drugTotal}
        biologicalTotal={biologicalTotal}
        setFilterVal={setFilterVal}
        setCancerFilterVal={setCancerFilterVal}
        cansiteName={cansiteName}
        geneCancer={geneCancer}
        geneCancerAllDataList={geneCancerAllDataList}
        cancerDropdown={cancerDropdown}
        morphologyDropdown={morphologyDropdown}
        setCancerFilterVal1={setCancerFilterVal1}
        drugsCountTotal={drugsCountTotal}
        drugsCount={drugsCount}
        recistCriteria={recistCriteria}
        recistCriteriaTotal={recistCriteriaTotal}
        somaticGermline={somaticGermline}
        variantTypeResponse={variantTypeResponse}
        somaticTotal={somaticTotal}
        variantTypeTotal={variantTypeTotal}
        fromDate={fromDate}
        toDate={toDate}
        cancerFilterVal1={cancerFilterVal1}
        selectedGenes={selectedGenes}
        immunoFilter={immunoFilter}
        targetedFilter={targetedFilter}
        citiesFilter={citiesFilter}
        hospitalsFilter={hospitalsFilter}
        morphologyFilterVal={morphologyFilterVal}
        setMorphologyFilterVal={setMorphologyFilterVal}
        setMorphologyDropdown={setMorphologyDropdown}
        setFromDate={setFromDate}
        setToDate={setToDate}
        setSelectedGenes={setSelectedGenes}
        setImmunoFilter={setImmunoFilter}
        setTargetedFilter={setTargetedFilter}
        setCitiesFilter={setCitiesFilter}
        setHospitalsFilter={setHospitalsFilter}
        colorMapping={colorMapping}
        dateRange={dateRange}
        hospitalCityData={hospitalCityData}
        hospitalCityTotal={hospitalCityTotal}
        hospitalNameData={hospitalNameData}
        immunoFilterData={immunoFilterData}
        targetedFilterData={targetedFilterData}
        citiesFilterData={citiesFilterData}
        hospitalsFilterData={hospitalsFilterData}
        testTypeGraphData={testTypeGraphData}
        proteinChangeDetails={proteinChangeDetails}
        morphologyData={morphologyData}
        setDateRange={setDateRange}
        SomaticGermlineAPICall={SomaticGermlineAPICall}
        BiomarkersAPICall={BiomarkersAPICall}
        TmbMsiPdlAPICall={TmbMsiPdlAPICall}
        TreatmentDetailsAPICall={TreatmentDetailsAPICall}
        DrugTherapyAPICall={DrugTherapyAPICall}
        GenderAgeDistrubtutionAPICall={GenderAgeDistrubtutionAPICall}
        HospitalAPICall={HospitalAPICall}
        morphologyDataAPICall={morphologyDataAPICall}
        fetchTestTypeData={fetchTestTypeData}
        CancerSitesLoader={CancerSitesLoader}
        MorphologySomaticGermlineLoader={MorphologySomaticGermlineLoader}
        BiomarkersLoader={BiomarkersLoader}
        TmbMsiPdlLoader={TmbMsiPdlLoader}
        TreatmentDetailsLoader={TreatmentDetailsLoader}
        DrugTherapyLoader={DrugTherapyLoader}
        GenderAgeDistrubtutionLoader={GenderAgeDistrubtutionLoader}
        HospitalTestTypeLoader={HospitalTestTypeLoader}
        testTypeGraphLoader={testTypeGraphLoader}
        morphologyDataLoader={morphologyDataLoader}
        targetedTherapy={targetedTherapy}
        targetedTherapyTotal={targetedTherapyTotal}
        doctorsDropdownDataFilter={doctorsDropdownDataFilter}
        doctorsDropdownData={doctorsDropdownData}
        isPdlChecked={isPdlChecked}
        setIsPdlChecked={setIsPdlChecked}
        ngsValue={ngsValue}
        setNgsValue={setNgsValue}
        cancerStage={cancerStage}
        cancerStageTotal={cancerStageTotal}
        wasManuallyCleared={wasManuallyCleared}
        setWasManuallyCleared={setWasManuallyCleared}
        setCancerSiteTop10={setCancerSiteTop10}
        testTypeFilter={testTypeFilter}
        setTestTypeFilter={setTestTypeFilter}
        testTypeFilterData={testTypeFilterData}
        setTestTypeFilterData={setTestTypeFilterData}
        setMorphologyData={setMorphologyData}
        setDoctorsDropdownDataFilter={setDoctorsDropdownDataFilter}
        setDoctorsDropdownData={setDoctorsDropdownData}
        setTestTypeGraphData={setTestTypeGraphData}
        geneDetectionStatus={geneDetectionStatus}
        setGeneDetectionStatus={setGeneDetectionStatus}
        minDate={apiDateRange.minDate}
        maxDate={apiDateRange.maxDate}
        dateRangeLoading={dateRangeLoading}
        hasApiData={hasApiData}
        clinicalSignificanceDropdown={clinicalSignificanceDropdown}
        setClinicalSignificanceDropdown={setClinicalSignificanceDropdown}
        clinicalSignificanceFilter={clinicalSignificanceFilter}
        setClinicalSignificanceFilter={setClinicalSignificanceFilter}
        clinicalSignificanceTotal={clinicalSignificanceTotal}
        hasLungCancerSite={hasLungCancerSite}
        userDetails={userDetails}
      />
    </>
  );
};
export default DashboardScreen;
